import { ROOT_ZONE, CLIMATE_ZONE } from './zones'

const V2_0 = '2_0'
const V2_1 = '2_1'

export default {
  [ROOT_ZONE]: [V2_0, V2_1],
  [CLIMATE_ZONE]: [V2_0, V2_1],
}
